import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { setDialog } from "../../features/dialog/dialogSlice";
import ErrorAlert from "../alerts/ErrorAlert";
import { useCreateReadingConfirmationMutation } from "../../features/fileData/fileDataApiSlice";
import ReadingConfirmationForm from "../../sections/@dashboard/files/FileData/ReadingConfirmationForm";
import ReadingConfirmationTable from "../../sections/@dashboard/files/ReadingConfirmation/ReadingConfirmationTable";

function FileDataCreateReadingDialog({ dialog, handleClose }) {
  const { data } = dialog;
  const { fileData } = data;
  const { handleSubmit, control, watch } = useForm({
    defaultValues: {
      ...fileData,
    },
  });

  const [createReadingConfirmation, { isError }] =
    useCreateReadingConfirmationMutation();

  const dispatch = useDispatch();

  const onSubmit = async (data) => {
    let newData = {};

    if (!data?.readingDueDate) {
      return alert("Bitte ein Datum für die Lesebestätigung angeben.");
    }

    if (!Array.isArray(data?.userList) || data.userList.length === 0) {
      return alert(
        "Bitte Benutzer oder Gruppe auswählen die eine Lesebestätigung erhalten sollen."
      );
    }

    newData.readingConfirmation = true;
    newData.newReadingConfirmation = true;
    newData.readingDueDate = data.readingDueDate;
    newData.userList = data.userList;

    // return console.log("data :>> ", data);

    // return console.log("newData :>> ", newData);

    try {
      let result = await createReadingConfirmation({
        _id: fileData._id,
        updateFields: { ...newData },
      }).unwrap();
      if (result.type === "success") {
        // console.log("result :>> ", result);
        dispatch(
          setDialog({
            title: "Lesebestätigung erstellt!",
            type: "SUCCESS",
            data: {
              successText: "Lesebestätigung wurde erfolgreich erstellt!",
            },
          })
        );
      }
    } catch (error) {
      console.log("error :>> ", error);
    }
  };

  return (
    <div>
      <Dialog open maxWidth="lg">
        <DialogTitle>{dialog?.title ?? ""}</DialogTitle>
        <DialogContent>
          <ReadingConfirmationTable fileData={fileData} />
          <form className="form">
            <ReadingConfirmationForm
              fileData={dialog.data.fileData}
              control={control}
              watch={watch}
            />
          </form>
        </DialogContent>
        {isError && (
          <div style={{ marginTop: 15 }}>
            <ErrorAlert errorMessage="Fehler beim Ändern des Dokuments" />
          </div>
        )}
        Handle readingConfirmation exists already
        <DialogActions>
          <Button
            type="submit"
            color="secondary"
            variant="contained"
            autoFocus
            onClick={handleSubmit(onSubmit)}
          >
            {"SPEICHERN"}
          </Button>
          <Button onClick={handleClose} color="primary">
            Beenden
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

FileDataCreateReadingDialog.propTypes = {
  dialog: PropTypes.object,
  handleClose: PropTypes.func,
};

export default FileDataCreateReadingDialog;
